export default __webpack_public_path__ + "static/media/Z_Zebra.2793a93b.mp3";